import db from "@/database";

export const findAll = () => {
  return db.pathogen.orderBy("name").toArray();
};

export const findOne = (id) => {
  return db.pathogen.get(id);
};
